import { ITariffPricing } from '../../model/types/ITariffPricing';

interface IParams {
  selectedPriceTab: number;
  tariffPrices: ITariffPricing[];
}

export const getTariffsInitialPrice = ({
  selectedPriceTab,
  tariffPrices,
}: IParams) => {
  if (selectedPriceTab === 0) {
    return tariffPrices.find(
      (tariffPrice) =>
        tariffPrice.period_value === 1 && tariffPrice.period_unit === 'month'
    )?.price;
  } else if (selectedPriceTab === 1) {
    return tariffPrices.find(
      (tariffPrice) =>
        tariffPrice.period_value === 3 && tariffPrice.period_unit === 'month'
    )?.price;
  } else if (selectedPriceTab === 2) {
    return tariffPrices.find(
      (tariffPrice) =>
        tariffPrice.period_value === 6 && tariffPrice.period_unit === 'month'
    )?.price;
  } else if (selectedPriceTab === 3) {
    return tariffPrices.find(
      (tariffPrice) =>
        tariffPrice.period_value === 12 && tariffPrice.period_unit === 'month'
    )?.price;
  } else {
    return tariffPrices.find(
      (tariffPrice) =>
        tariffPrice.period_value === 1 && tariffPrice.period_unit === 'month'
    )?.price;
  }
};
